var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlreadyClaimedError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 0H0V20H240V0Z",
    fill: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 100H0V120H240V100Z",
    fill: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 100C114.091 100 132 82.0914 132 60C132 37.9086 114.091 20 92 20C69.9086 20 52 37.9086 52 60C52 82.0914 69.9086 100 92 100Z",
    fill: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 100C166.091 100 184 82.0914 184 60C184 37.9086 166.091 20 144 20C121.909 20 104 37.9086 104 60C104 82.0914 121.909 100 144 100Z",
    fill: "#ECD069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 92C161.673 92 176 77.6731 176 60C176 42.3269 161.673 28 144 28C126.327 28 112 42.3269 112 60C112 77.6731 126.327 92 144 92Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1 45.8999L129.9 74.0999",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1 74.0999L129.9 45.8999",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 40V80",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 60H124",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 100C62.0914 100 80 82.0914 80 60C80 37.9086 62.0914 20 40 20C17.9086 20 0 37.9086 0 60C0 82.0914 17.9086 100 40 100Z",
    fill: "#45DAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 29.6001C74.6 37.0001 80 47.8001 80 60.0001C80 72.2001 74.6 83.0001 66 90.4001C57.4 83.0001 52 72.2001 52 60.0001C52 47.8001 57.4 37.0001 66 29.6001Z",
    fill: "#588AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 90C227.464 90 240 77.464 240 62C240 46.536 227.464 34 212 34C196.536 34 184 46.536 184 62C184 77.464 196.536 90 212 90Z",
    fill: "#F0616D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 60H100",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5 51.5L100 60L91.5 68.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211 77V45H213V77H211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.277 68H226V72H198L198.277 68Z",
    fill: "#F0616D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlreadyClaimedError);
export default __webpack_public_path__ + "static/media/already-claimed-error.339b43ef9deead4ee89a4ad203afd3ec.svg";
export { ForwardRef as ReactComponent };